import React from 'react';
import PropTypes from 'prop-types';

import TableHeaderCheckboxAll from '../../../../components/Table/CheckAll';
import Filter from '../../../../components/Filters/StatusFilter';

import { generateTableHead } from '../../helpers';

const Head = ({ access, filters, values, onChangeCheck, handleSelectMass }) => (
  <thead>
    <tr>
      {generateTableHead(access).map((item, index) => {
        switch (item.title) {
        case 'All':
          return (
            <TableHeaderCheckboxAll
              key={index}
              handleSelect={handleSelectMass}
              transKey="Table.MassCounterUpdates"
              transValue="{{count}} updates selected"
              values={values}
              onChangeCheck={onChangeCheck}
              accessMassActions={[{ id: 1, title: 'Delete' }]}
              configAccess={access}
              pullRight={false}
            />
          );

        case 'Update':
          return (
            <th key={index} className="updates-filter">
              <Filter title={item.title} items={filters} queryRequest="type" />
            </th>
          );

        case 'Delete':
          return <th key={index}>{' '}</th>;

        default:
          return <th key={index}>{item.title}</th>;
        }
      })}
    </tr>
  </thead>
);

Head.propTypes = {
  access: PropTypes.object,
  filters: PropTypes.array,
  values: PropTypes.array,
  onChangeCheck: PropTypes.func,
  handleSelectMass: PropTypes.func,
};

export default Head;
